<div class="flex flex-col h-full">
  <div>
    <h1>Konvertering</h1>
  </div>
  @if (id()) {
    <div class="flex-1 2xl:overflow-hidden pb-4">
      <app-konvertering-detail [id]="konverteringId()!"></app-konvertering-detail>
    </div>
  } @else {
    <div class="flex-1 overflow-hidden">
      <app-konvertering-grid [hidden]="id() !== undefined"></app-konvertering-grid>
    </div>
  }
</div>
